function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "B88618D4-CF53-48F4-A4C8-1BDD445FC684@3x");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "current",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Assets-for-exporting",
  transform: "translate(-57.000000, -94.000000)",
  fill: "current"
}, React.createElement("path", {
  d: "M66.4452996,107.529975 L62.3117056,110.609284 C61.868806,110.939221 61.2422982,110.847647 60.9123613,110.404747 C60.7160923,110.14128 60.6617561,109.798215 60.7670032,109.486992 L62.4182497,104.604152 L62.4182497,104.604152 L58.2123016,101.624429 C57.7616495,101.305163 57.6551404,100.68102 57.9744069,100.230368 C58.1643284,99.9622897 58.4738122,99.8045998 58.8023254,99.8085228 L63.9564459,99.8700708 L63.9564459,99.8700708 L65.490621,94.9491916 C65.6550024,94.4219372 66.2156839,94.1277704 66.7429383,94.2921517 C67.0565853,94.389937 67.302193,94.6355447 67.3999782,94.9491916 L68.9341534,99.8700708 L68.9341534,99.8700708 L74.0882738,99.8085228 C74.6405192,99.8019281 75.0935485,100.244265 75.1001432,100.796511 C75.1040661,101.125024 74.9463763,101.434508 74.6782976,101.624429 L70.4723496,104.604152 L70.4723496,104.604152 L72.123596,109.486992 C72.3005211,110.010171 72.0198271,110.577717 71.4966484,110.754642 C71.185426,110.85989 70.8423606,110.805553 70.5788936,110.609284 L66.4452996,107.529975 L66.4452996,107.529975 Z",
  id: "Star-Copy-11"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/smallstar-filled.6d5e802b.svg";
export { SvgComponent as ReactComponent };